import Vue, { CreateElement } from 'src/vue'
import { Component } from 'vue-property-decorator'

import { ActiveMembersStatistics } from '@src/routes/club/active-members'
import { RPEStatistics } from '@src/routes/club/rpe'
import { SubscriptionsStatistics } from '@src/routes/club/subscriptions'
import { track } from '@src/util/functions'

@Component
export class ClubStatistics extends Vue {

  constructor () {
    super()
    track('/club/statistics')
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MY_CLUB')} - ${this.$root.$t('PAGE.CLUB.CLUB_STATISTICS.TAB_NAME')}`
  }

  render (h: CreateElement) {
    return <div class='club-statistics'>
      <ActiveMembersStatistics />
      <RPEStatistics />
      <SubscriptionsStatistics />
    </div>
  }
}
